import { render, staticRenderFns } from "./vacationDetail.vue?vue&type=template&id=04d1c962&scoped=true"
import script from "./vacationDetail.vue?vue&type=script&lang=js"
export * from "./vacationDetail.vue?vue&type=script&lang=js"
import style0 from "./vacationDetail.vue?vue&type=style&index=0&id=04d1c962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d1c962",
  null
  
)

export default component.exports